var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.value
    ? _c("div", [
        _c("img", {
          staticClass: "responsive",
          class: _vm.css,
          attrs: { src: _vm.value },
          on: {
            click: function($event) {
              _vm.opened = !_vm.opened
            }
          }
        })
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }